import React from 'react'
import {Link} from 'react-router-dom'
import { AiOutlineArrowRight } from "react-icons/ai";
import { MdOutlinePrivacyTip } from "react-icons/md";
import { BsPhoneVibrate } from "react-icons/bs";
import { BiHelpCircle } from "react-icons/bi";
import { BsInstagram } from "react-icons/bs";
import { BiLogoLinkedin } from "react-icons/bi";
import { FaYoutube } from "react-icons/fa";
import { BsTwitter } from "react-icons/bs";
import { FaFacebook } from "react-icons/fa";
import appstore from '../Image/appstore.avif';
import logo from '../Image/logo.avif'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons';

function Footer() {
  return (
    <>
    <div className=''> 
    {/* ---------------------------mobile view--------------------- */}
    <script src="https://code.jquery.com/jquery-3.6.0.min.js"></script>
    <div className='Footer_Main_box d-sm-block d-md-none'>
    <div className=''>
        <div className='mobile_footer py-4'>
            <div className='container pb-4'>
                <div className='row'>
                    <div className='col-md-12'>
                    <div className=''>
                        <img className='foote_img' src={logo}></img>
                    </div>
                    <div>
                    <h6 className=' fs-5 px-3 foote_text mobile_footer_link_color pt-4'>Rule the World With Elite.</h6>
                    </div>
                    </div>

                    <div className='col-md-12'>
                        <div className='row mt-4'>
                            <div className='col-6'>
                            <div className='d-flex justify-content-start'>
                                <ul className='navbar-nav footer_link_color'>
                                <h5 className='Border_link_footer pb-3'>Quick Links</h5>
                                    <Link to="/"><li className='pt-3'><a className='' href=''>Home</a></li></Link>
                                    <Link to="/About-us"><li className='py-3'><a className='' href=''>About Us</a></li></Link>
                                    <Link to="/Privacy-Policy"><li className=''><a className='' href=''>Privacy Policy & Refund Policy</a></li></Link>
                                    <Link to="/T&C"><li className='py-3'><a className='' href=''>Terms & Conditions</a></li></Link>
                                </ul>
                            </div>
                            </div>
                            <div className='col-6'>
                            <div className=' d-flex justify-content-center'>
                                <ul className='navbar-nav footer_link_color'>
                                <h5 className='Border_link_footer pb-3'>Courses</h5>
                                <Link to="/ML"><li className='pt-3'><a className='' href=''>Machine Learning</a></li></Link>
                                <Link to="/WD"><li className='py-3'><a className='' href=''>Web Development</a></li></Link>
                                <Link to="/AI"><li className=''><a className='' href=''>Artificial Intelligence</a></li></Link>
                                <Link to="/DS"><li className='py-3'><a className='' href=''>Data Science</a></li></Link>
                                </ul>
                            </div>
                            </div>
                            <div className='col-12 mt-4'>
                            <div className=' d-flex justify-content-center'>
                                <ul className='navbar-nav footer_link_color'>
                                <h5 className='Border_link_footer pb-3'>Contact</h5>
                                <a href='tel:+919318338245'><li className='pt-3'><div><span className=' contact_text '>+91 93183 38245</span></div></li></a>
                                <a href='mailto:support@internselite.com'><li><div><span className='contact_text'>support@internselite.com</span></div></li></a>
                                <div className='contact-text-address py-3'><span className='Contact_text'>Unit No.-35A&B, Ground Floor, Tower B1, Spaze-I-Tech Park, Sohna Road, Sector-49, Gurgaon, Haryana-122018</span></div>
                                <div className=''>
                                    <iframe className='' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3509.202925444482!2d77.04124057502575!3d28.413133144010956!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x83376897e758e91b%3A0x198189118ca0998b!2sInternsElite%20Edutech%20Private%20Limited!5e0!3m2!1sen!2sin!4v1695194964515!5m2!1sen!2sin" width="100%" height="100"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade">
                                    </iframe>
                                </div>
                                </ul>
                            </div>
                            </div>
                        </div>
                    </div>  
                </div>
            </div>
            <div className='row'>
                <p className='foote_text fs-5 mobile_footer_link_color px-5 text-center fw-bold'>Download Our App</p>
            <div className="col-6">
                <div className='text-center'>
                    <a href='https://play.google.com/store/apps/details?id=co.diy.jzlzp'  target='_blank'><img alt='Get it on Google Play' className='mobile_playstore_icon' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/></a>
                </div>
            </div>
            <div className='col-6 pt-2 text-center'>
            <a href='https://apps.apple.com/in/app/myinstitute/id1472483563'  target='_blank'><img alt='Get it on Google Play' className='mobile_appstore_icon' src={appstore}/></a>
            </div>
            <div>
            
            </div>
            </div>
        </div>
        <div className='pt-4'>
            <div className='container'>
                <div className='row'>
                <div className='col-md-12 d-flex justify-content-center border-bottom pb-3'>
                    <div className='d-inline mx-3'><a href='https://www.instagram.com/internselite07/?hl=en' target='_blank'><BsInstagram  size="23px" color="#3d2e7c" /></a></div>
                    <div className='d-inline mx-3'><a href='https://www.facebook.com/people/InternsElite/61551386850161/' target='_blank'><FaFacebook  size="23px" color="#3d2e7c" /></a></div>
                    <div className='d-inline mx-3'><a href='https://www.linkedin.com/company/internselite/' target='_blank'><BiLogoLinkedin  size="23px" color="#3d2e7c" /></a></div>
                    <div className='d-inline mx-3'><a href='https://youtube.com/@Internselite07?feature=shared' target='_blank'><FaYoutube  size="23px" color="#3d2e7c" /></a></div>
                    <div className='d-inline mx-3'><a href='https://twitter.com/internselite?t=3ZDl-YQZa3p1tRPfVNvfDw&s=09' target='_blank'><FontAwesomeIcon className='icon_footer_twitter' color="#3d2e7c"  icon={faXTwitter} /></a></div>
                </div>
                <div className='col-md-12 pt-3'>
                    <div className='footer_last_box text-center'>
                        <p>Internselite Edutech Private Limited © 2023. All Rights Reserved.</p>
                    </div>
                </div>
                <div className='col-md-12 pt-2 fw-bold footer_last_box text-center'>
                <a className='px-2 fs-6  text-dark' href='https://www.snsoft.tech/'  target='_blank'>Managed by InnoSN Soft Tech.</a>
                </div>
                </div>
            </div>
        </div>
    </div>
    </div>

    {/* ------------------------desktop view------------------------ */}
    <script src="https://code.jquery.com/jquery-3.6.0.min.js"></script>
    <div className='Footer_Main_box'>
    <div className='d-none d-md-block'>
        <div className='footer py-4'>
            <div className='container pb-2'>
                <div className='row'>
                    <div className='col-md-4 pt-2'>
                    <div className='pt-2'>
                        <img className='foote_img' src={logo}></img>
                    </div>
                    <div>
                    <h5 className=' foote_text footer_link_color pt-4 pb-3'>Rule the World With Elite.</h5>
                    <div className='row'>
                    <p className='foote_text fs-5 footer_link_color fw-bold'>Download Our App</p>
                    <div className="col-12">
                    <a href='https://play.google.com/store/apps/details?id=co.diy.jzlzp'  target='_blank'><img alt='Get it on Google Play' className='playstore_icon' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/></a>
                    </div>
                    <div className='col-12 pt-2'>
                    <a href='https://apps.apple.com/in/app/myinstitute/id1472483563'  target='_blank'><img alt='Get it on Google Play' className='appstore_icon' src={appstore}/></a>
                    </div>
                    <div>
                    
                    </div>
                    </div>
                    </div>
                    </div>

                    <div className='col-md-8'>
                        <div className='row mt-4'>
                            <div className='col-md-4'>
                            <div className='d-flex justify-content-end'>
                                <ul className='navbar-nav footer_link_color'>
                                <h5 className='Border_link_footer pb-3'>Quick Links</h5>
                                    <Link to="/"><li className='pt-4'><a className='px-2' href=''>Home</a></li></Link>
                                    <Link to="/About-us"><li className='py-3'><a className='px-2 ' href=''>About Us</a></li></Link>
                                    <Link to="/Privacy-Policy"><li className=''><a className='px-2' href=''>Privacy Policy & Refund Policy</a></li></Link>
                                    <Link to="/T&C"><li className='py-3'><a className='px-2' href=''>Terms & Conditions</a></li></Link>
                                </ul>
                            </div>
                            </div>
                            <div className='col-md-4'>
                            <div className=' d-flex justify-content-center'>
                                <ul className='navbar-nav footer_link_color'>
                                <h5 className='Border_link_footer pb-3'>Courses</h5>
                                <Link to="/ML"><li className='pt-4'><a className='px-2' href=''>Machine Learning</a></li></Link>
                                <Link to="/WD"><li className='py-3'><a className='px-2' href=''>Web Development</a></li></Link>
                                <Link to="/AI"><li className=''><a className='px-2' href=''>Artificial Intelligence</a></li></Link>
                                <Link to="/DS"><li className='py-3'><a className='px-2' href=''>Data Science</a></li></Link>
                                </ul>
                            </div>
                            </div>
                            <div className='col-md-4'>
                            <div className=' d-flex justify-content-center'>
                                <ul className='navbar-nav footer_link_color'>
                                <h5 className='Border_link_footer pb-3'>Contact</h5>
                                <a href='tel:+919318338245'><li className='pt-4'><span className=' contact_text '>+91 93183 38245</span></li></a>
                                <a href='mailto:support@internselite.com'><li><div><span className='contact_text'>support@internselite.com</span></div></li></a>
                                <div className='contact-text-address py-3'><span className='Contact_text'>Unit No.-35A&B, Ground Floor, Tower B1, Spaze-I-Tech Park, Sohna Road, Sector-49, Gurgaon, Haryana-122018</span></div>
                                <div className=''>
                                    <iframe className='' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3509.202925444482!2d77.04124057502575!3d28.413133144010956!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x83376897e758e91b%3A0x198189118ca0998b!2sInternsElite%20Edutech%20Private%20Limited!5e0!3m2!1sen!2sin!4v1695194964515!5m2!1sen!2sin" width="100%" height="100"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade">
                                    </iframe>
                                </div>
                                </ul>
                            </div>
                            </div>
                        </div>
                    </div>  
                </div>
            </div>
        </div>
        <div className='pt-4'>
            <div className='container'>
                <div className='row'>
                <div className='col-md-4'>
                    <div className='d-inline mx-3'><a href='https://www.instagram.com/internselite07/?hl=en' target='_blank'><BsInstagram  size="23px" color="#3d2e7c" /></a></div>
                    <div className='d-inline mx-3'><a href='https://www.facebook.com/people/InternsElite/61551386850161/' target='_blank'><FaFacebook  size="23px" color="#3d2e7c" /></a></div>
                    <div className='d-inline mx-3'><a href='https://www.linkedin.com/company/internselite/' target='_blank'><BiLogoLinkedin  size="23px" color="#3d2e7c" /></a></div>
                    <div className='d-inline mx-3'><a href='https://youtube.com/@Internselite07?feature=shared' target='_blank'><FaYoutube  size="23px" color="#3d2e7c" /></a></div>
                    <div className='d-inline mx-3'><a href='https://twitter.com/internselite?t=3ZDl-YQZa3p1tRPfVNvfDw&s=09' target='_blank'><FontAwesomeIcon className='icon_footer_twitter' color="#3d2e7c"  icon={faXTwitter} /></a></div>
                </div>
                <div className='col-md-5'>
                    <div className='footer_last_box'>
                        <p>Internselite Edutech Private Limited © 2023. All Rights Reserved.</p>
                    </div>
                </div>
                <div className='col-md-3 footer_last_box text-center'>
                <a className='px-2 fs-6  text-dark' href='https://www.snsoft.tech/'  target='_blank'>Managed by InnoSN Soft Tech.</a>
                </div>
                </div>
            </div>
        </div>
    </div>
    </div>
    </div>
    </>
  )
}

export default Footer
